import produce from 'immer';
import { MOVE_SCOUT_GROUP_COLUMN, MOVE_SCOUT_MEMBER_CARD, KANBAN_GET_SCOUT_GROUP_LIST_REQUEST, KANBAN_GET_SCOUT_GROUP_LIST, SCOUT_GROUP_SAVE_REQUEST, SCOUT_GROUP_SAVE_SUCCESS, SCOUT_GROUP_SAVE_FAILURE, SCOUT_GET_GEO_REGION_REQUEST, SCOUT_GET_GEO_REGION, SCOUT_GET_FARM_USERS_LIST_REQUEST, SCOUT_GET_FARM_USERS_LIST, ADD_SCOUT_GROUP, REMOVE_SCOUT_MEMBER, REMOVE_SCOUT_GROUP, EDIT_SCOUT_GROUP, SET_SCOUT_SEARCH_TEXT, SCOUT_GROUP_SELECTION, RESET_SCOUT_GROUP, SET_SCOUT_ACTIVE_TAB } from "../constants/action-types";
import { compareTwo } from '../components/scout-kanban/utils';


const getColumns = (count, selected) =>
    Array.from({ length: count }, (v, k) => k).map(k => ({
        columnId: `column${k + 1}`,
        scoutGroupId: (selected && k < selected.length) ? selected[k] : null
    }));


const initialState = {
    isRequestingScoutGroupList: false,
    isRequestingSave: false,
    isRequestingGeoRegion: false,
    activeTab: "",
    sgList: [],
    sgListById: {},
    geoRegionList: [],
    columns: getColumns(5),
    farmUsersList: {
        isRequesting: false,
        payload: []
    },
    scoutSearchText: "",
}


export default (state = initialState, action) => {
    switch (action.type) {
        case KANBAN_GET_SCOUT_GROUP_LIST_REQUEST:
            return {
                ...state, isRequestingCrew: true,
                sgList: initialState.sgList
            };
        case MOVE_SCOUT_GROUP_COLUMN: {
            const { oldColumnIndex, newColumnIndex } = action.payload;
            const newColumns = Array.from(state.columns);
            const [removedList] = newColumns.splice(oldColumnIndex, 1);
            newColumns.splice(newColumnIndex, 0, removedList);
            return { ...state, columns: newColumns };
        }
        case MOVE_SCOUT_MEMBER_CARD: {

            let { oldCardIndex, newCardIndex, sourceScoutGroupId, destScoutGroupId, scoutMemberId } = action.payload;

            if (destScoutGroupId === 'geoRegion' || destScoutGroupId === 'farmusers') {
                return { ...state, sgListById: { ...state.sgListById } }
            }

            // Move within the same list
            if (sourceScoutGroupId === destScoutGroupId) {
                const newCards = Array.from(state.sgListById[sourceScoutGroupId].scout_member_list);
                const [removedCard] = newCards.splice(oldCardIndex, 1);
                newCards.splice(newCardIndex, 0, removedCard);
                return {
                    ...state,
                    sgListById: { ...state.sgListById, [sourceScoutGroupId]: { ...state.sgListById[sourceScoutGroupId], scout_member_list: newCards } }
                };
            }

            //Move from GeoRegion to Column List.
            if (sourceScoutGroupId === "geoRegion" && sourceScoutGroupId !== destScoutGroupId) {
                if (scoutMemberId) scoutMemberId = scoutMemberId.replace('shape_', "");
                const destinationCards = state.sgListById[destScoutGroupId] ? Array.from(state.sgListById[destScoutGroupId].scout_member_list) : [];

                let shapeDetails = null;

                let isAlreadyGeoRegionPresent = destinationCards.length > 0 ? destinationCards.filter((destCard) => destCard.scout_member_id === scoutMemberId) : [];

                if (isAlreadyGeoRegionPresent.length > 0) return { ...state, sgListById: { ...state.sgListById } };

                const getPresentShapeDetail = (i) => {
                    return state.geoRegionList[i].shapes.find((shape) => shape.geo_shape_uuid === scoutMemberId)
                }

                for (let i = 0; i < state.geoRegionList.length; i++) {
                    shapeDetails = getPresentShapeDetail(i);
                    if (shapeDetails) break;
                }

                const addCard = {
                    scout_uuid: state.sgListById[destScoutGroupId].scout_uuid,
                    scout_member_id: scoutMemberId,
                    scout_type_id: 2,
                    scout_member_name: shapeDetails ? shapeDetails.geo_shape_name : 'N/A',
                    status_id: 1
                };

                destinationCards.splice(newCardIndex, 0, addCard);

                return {
                    ...state, sgListById: {
                        ...state.sgListById,
                        [destScoutGroupId]: { ...state.sgListById[destScoutGroupId], scout_member_list: destinationCards, isChanged: true }
                    }
                };
            }


            //Move from Users to Column List.
            if (sourceScoutGroupId === "farmusers" && sourceScoutGroupId !== destScoutGroupId) {
                if (scoutMemberId) scoutMemberId = scoutMemberId.replace('user_', "");
                const destinationCards = state.sgListById[destScoutGroupId] ? Array.from(state.sgListById[destScoutGroupId].scout_member_list) : [];

                let userDetails = null;

                let isAlreadyGeoRegionPresent = destinationCards.length > 0 ? destinationCards.filter((destCard) => destCard.scout_member_id === scoutMemberId) : [];

                if (isAlreadyGeoRegionPresent.length > 0) return { ...state, sgListById: { ...state.sgListById } };

                if (state.farmUsersList && state.farmUsersList.payload.length > 0) {
                    userDetails = state.farmUsersList.payload.find((user) => user.user_id === Number(scoutMemberId));
                }

                const addCard = {
                    scout_uuid: state.sgListById[destScoutGroupId].scout_uuid,
                    scout_member_id: scoutMemberId,
                    scout_type_id: 17,
                    scout_member_name: userDetails ? userDetails.name : 'N/A',
                    status_id: 1
                };

                destinationCards.splice(newCardIndex, 0, addCard);
                return {
                    ...state, sgListById: {
                        ...state.sgListById,
                        [destScoutGroupId]: { ...state.sgListById[destScoutGroupId], scout_member_list: destinationCards, isChanged: true }
                    }
                };
            }

            // Move card from one list to another
            const sourceCards = state.sgListById[sourceScoutGroupId] ? Array.from(state.sgListById[sourceScoutGroupId].scout_member_list) : [];
            const [removedCard] = sourceCards.splice(oldCardIndex, 1);
            const destinationCards = state.sgListById[destScoutGroupId] ? Array.from(state.sgListById[destScoutGroupId].scout_member_list) : [];
            const getScoutMemberId = scoutMemberId ? scoutMemberId.split("_") : [];
            if (getScoutMemberId && getScoutMemberId.length > 0) {
                const isAlreadyScoutMemberPresent = destinationCards.filter((destination) => destination.scout_member_id === getScoutMemberId[1]);
                if (isAlreadyScoutMemberPresent && isAlreadyScoutMemberPresent.length > 0) {
                    return { ...state, sgListById: { ...state.sgListById } }
                }
            }
            destinationCards.splice(newCardIndex, 0, removedCard);
            return {
                ...state, sgListById: {
                    ...state.sgListById,
                    [sourceScoutGroupId]: { ...state.sgListById[sourceScoutGroupId], scout_member_list: sourceCards, isChanged: true },
                    [destScoutGroupId]: { ...state.sgListById[destScoutGroupId], scout_member_list: destinationCards, isChanged: true }
                }
            };
        }
        case KANBAN_GET_SCOUT_GROUP_LIST: {
            const sgList = (action.payload && action.payload.length > 0) ? action.payload : [];
            const sgListById = {};
            const columns = getColumns(5);
            if (sgList && sgList.length > 0) {
                sgList.forEach((item, index) => {
                    if (index <= 5) {
                        if (columns[index]) columns[index].scoutGroupId = item.scout_group_uuid;
                    }
                    sgListById[item.scout_group_uuid] = {
                        scout_group_name: item.scout_group_name,
                        scout_group_uuid: item.scout_group_uuid,
                        scout_entity_type_id: item.scout_entity_type_id,
                        status_id: item.status_id,
                        scout_member_list: item.scout_members
                    }
                })
            }
            return {
                ...state,
                sgListById,
                sgList,
                columns
            }
        }
        case SCOUT_GROUP_SAVE_REQUEST:
            return { ...state, isRequestingSave: true };
        case SCOUT_GROUP_SAVE_SUCCESS: {
            const sgList = action.sgList;
            let sgListById = { ...state.sgListById };
            for (let sg in sgListById) {
                if (sgListById[sg] && sgListById[sg].hasOwnProperty('isChanged')) {
                    sgListById[sg].isChanged = false;
                }
            }
            return { ...state, isRequestingSave: false, sgList, sgListById };
        }
        case SCOUT_GROUP_SAVE_FAILURE:
            return { ...state, isRequestingSave: false };
        case SCOUT_GET_GEO_REGION_REQUEST:
            return {
                ...state,
                isRequestingGeoRegion: true
            }
        case SCOUT_GET_GEO_REGION: {
            const payload = action.payload ? action.payload : [];
            return { ...state, geoRegionList: payload, isRequestingGeoRegion: false }
        }
        case SCOUT_GET_FARM_USERS_LIST_REQUEST:
            state = produce(state, s => {
                s.farmUsersList = {
                    isRequesting: true,
                    payload: []
                }
            });
            break;
        case SCOUT_GET_FARM_USERS_LIST:
            state = {
                ...state,
                farmUsersList: {
                    isRequesting: false,
                    payload: action.payload ? action.payload : []
                }
            }
            break;
        case ADD_SCOUT_GROUP:
            const newScoutGroup = action.payload;
            const scoutGroupColumns = [...state.columns];
            const findIndex = scoutGroupColumns.findIndex(e => e.scoutGroupId === null);
            if (findIndex >= 0) scoutGroupColumns[findIndex].scoutGroupId = newScoutGroup.scout_group_uuid;
            return {
                ...state,
                columns: scoutGroupColumns,
                sgListById: {
                    ...state.sgListById,
                    [newScoutGroup.scout_group_uuid]: { ...newScoutGroup }
                }
            }
        case EDIT_SCOUT_GROUP: {
            const scoutGroup = action.payload;
            let sgListById = { ...state.sgListById };
            if (sgListById[scoutGroup.scout_group_uuid]) {
                sgListById[scoutGroup.scout_group_uuid].scout_group_name = scoutGroup.scout_group_name;
                sgListById[scoutGroup.scout_group_uuid]['isChanged'] = true;
            }
            return {
                ...state,
                sgListById: {
                    ...state.sgListById,
                    ...sgListById
                }
            }
        }
        case REMOVE_SCOUT_MEMBER:
            const sgData = action.payload;
            const { scoutGroupId, smId } = sgData;
            const sgListById = state.sgListById;
            if (sgListById[scoutGroupId]) {
                const removeItem = sgListById[scoutGroupId].scout_member_list.filter((sm) => sm.scout_member_id === smId);
                if (removeItem.length > 0) {
                    const removeSm = sgListById[scoutGroupId].scout_member_list.filter((sm) => sm.scout_member_id !== smId);
                    return {
                        ...state, sgListById: {
                            ...state.sgListById,
                            [scoutGroupId]: { ...state.sgListById[scoutGroupId], scout_member_list: removeSm, isChanged: true }
                        }
                    }
                }
            }
            return { ...state, sgListById: { ...state.sgListById } };

        case REMOVE_SCOUT_GROUP: {
            const { scoutGroupId } = action.payload;
            let sgListById = state.sgListById;
            let columns = state.columns
            if (sgListById[scoutGroupId]) {
                delete sgListById[scoutGroupId];
                return { ...state, sgListById };
            }
            return state = { ...state, sgListById: { ...state.sgListById }, columns };
        }
        case SET_SCOUT_SEARCH_TEXT:
            const { searchText } = action;
            return { ...state, scoutSearchText: searchText }
        case SCOUT_GROUP_SELECTION: {
            const columns = [...state.columns];
            const sgListById = { ...state.sgListById };
            const oldSelected = columns.filter(e => e.scoutGroupId !== null).map(e => e.scoutGroupId);
            const newSelected = action.payload;
            const { added, removed } = compareTwo(oldSelected, newSelected);
            for (const crewId of removed) {
                const findIndex = columns.findIndex(e => e.scoutGroupId === crewId);
                if (findIndex < 0) continue;
                columns[findIndex].scoutGroupId = null;
                if (sgListById.hasOwnProperty(scoutGroupId)) delete sgListById[scoutGroupId];
            }

            for (const crewId of added) {
                const findIndex = columns.findIndex(e => e.scoutGroupId === null);
                if (findIndex < 0) continue;
                columns[findIndex].scoutGroupId = crewId;
            }

            return { ...state, columns, sgListById };
        }
        case RESET_SCOUT_GROUP: {
            const sgList = state.sgList;
            const sgListById = {};
            const columns = getColumns(5);
            if (sgList && sgList.length > 0) {
                sgList.forEach((item, index) => {
                    if (index <= 5) {
                        if (columns[index]) columns[index].scoutGroupId = item.scout_group_uuid;
                    }
                    sgListById[item.scout_group_uuid] = {
                        scout_group_name: item.scout_group_name,
                        scout_group_uuid: item.scout_group_uuid,
                        scout_entity_type_id: item.scout_entity_type_id,
                        status_id: item.status_id,
                        scout_member_list: item.scout_members
                    }
                })
            }

            return {
                ...state,
                sgListById,
                sgList,
                columns
            }
        }
        case SET_SCOUT_ACTIVE_TAB:
            const { payload } = action;
            return { ...state, activeTab: payload }

        default:
            break;
    }
    return state;
}